export default __webpack_public_path__ + "static/media/fenge.1ad55bd6.png";